import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AppLayout     from './components/layout/AppLayout';
import Login         from './pages/Login';
import Dashboard     from './pages/Dashboard';
import Pacientes     from './pages/Pacientes';
import Turnos        from './pages/Turnos';
import Historia      from './pages/Historia';
import Odontograma   from './pages/Odontograma';
import Laboratorio   from './pages/Laboratorio';
import Farmacia      from './pages/Farmacia';
import Facturacion   from './pages/Facturacion';
import Configuracion from './pages/Configuracion';
import Reportes      from './pages/Reportes';
import MigracionEvoluciones from './pages/MigracionEvoluciones';
import RecetasMedicas from './pages/RecetasMedicas';
import ResultadosPortal from './pages/ResultadosPortal';
import VerificarFirma from './pages/VerificarFirma';

function PrivateRoute({ children }) {
  const { usuario } = useAuth();
  return usuario ? children : <Navigate to="/login" replace />;
}

// Protege una ruta según el tipo_usuario del JWT
// Si el usuario no tiene permiso, lo redirige al Dashboard
function RolRoute({ children, roles }) {
  const { usuario } = useAuth();
  if (!usuario) return <Navigate to="/login" replace />;
  if (roles.includes('*')) return children;
  const tipo = usuario.esDBA ? 'DBA' : (usuario.tipo_usuario || 'MEDICO').toUpperCase().trim();
  if (roles.includes(tipo)) return children;
  return <Navigate to="/" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><AppLayout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="pacientes" element={
              <RolRoute roles={['*']}><Pacientes /></RolRoute>
            } />
            <Route path="turnos" element={
              <RolRoute roles={['MEDICO','SECRETARIA','DBA','ADMINISTRADOR']}><Turnos /></RolRoute>
            } />
            <Route path="historia" element={
              <RolRoute roles={['MEDICO','SECRETARIA','DBA','ADMINISTRADOR']}><Historia /></RolRoute>
            } />
            <Route path="recetas" element={
              <RolRoute roles={['MEDICO','SECRETARIA','DBA','ADMINISTRADOR']}><RecetasMedicas /></RolRoute>
            } />
            <Route path="odontograma" element={
              <RolRoute roles={['MEDICO','DBA','ADMINISTRADOR']}><Odontograma /></RolRoute>
            } />
            {/* MEDICO agregado: en Vintage el médico necesita poder solicitar/
                ver laboratorio directamente, no solo Laboratorio/DBA/Admin. */}
            <Route path="laboratorio" element={
              <RolRoute roles={['MEDICO','LABORATORIO','DBA','ADMINISTRADOR']}><Laboratorio /></RolRoute>
            } />
            {/* Por orden explícita de la Dra. Bombón: ninguna Secretaria (Andrea incluida)
                debe poder entrar a Farmacia — solo Médico, Administrador y DBA. */}
            <Route path="farmacia" element={
              <RolRoute roles={['MEDICO','DBA','ADMINISTRADOR']}><Farmacia /></RolRoute>
            } />
            {/* MEDICO agregado: Farmacia ya manda al médico a esta pantalla justo
                después de dispensar (con el paciente y sus productos cargados,
                listos para cobrar) — sin este rol aquí, el médico se topaba con
                "acceso denegado" al llegar. */}
            <Route path="facturacion" element={
              <RolRoute roles={['MEDICO','SECRETARIA','LABORATORIO','DBA','ADMINISTRADOR']}><Facturacion /></RolRoute>
            } />
            <Route path="reportes" element={
              <RolRoute roles={['DBA','ADMINISTRADOR','SECRETARIA']}><Reportes /></RolRoute>
            } />
            {/* Módulo temporal para transcribir evoluciones del sistema anterior —
                le faltaba por completo del menú y las rutas, no era un tema de rol. */}
            <Route path="migracion-evoluciones" element={
              <RolRoute roles={['MEDICO','SECRETARIA','DBA','ADMINISTRADOR']}><MigracionEvoluciones /></RolRoute>
            } />
            <Route path="configuracion" element={
              <RolRoute roles={['DBA','ADMINISTRADOR','SECRETARIA']}><Configuracion /></RolRoute>
            } />
          </Route>
          <Route path="/resultados/:token" element={<ResultadosPortal/>}/>
          <Route path="/verificar/:nro/:hash" element={<VerificarFirma/>}/>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
